import { EditOutlined, MoreVertOutlined } from '@mui/icons-material';
import { Menu, MenuItem, MenuList, Stack } from '@mui/material';
import React, { useState } from 'react';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { FSSecondaryButton } from '@/ui/components/button/FSSecondaryButton';
import { useDialogConfirm } from '@/ui/components/confirm-dialog/useDialogConfirm';
import { translate } from '@/ui/i18n';

export function HeaderButtons({
  onClickEdit,
  onClickDelete,
  onClickExportReport,
}: {
  onClickEdit: () => void;
  onClickDelete: () => void;
  onClickExportReport: () => void;
}) {
  const dialogConfirm = useDialogConfirm();

  const onClickDeleteConfirmBefore = async () => {
    const response = await dialogConfirm({
      title: translate('DeleteProject.Message.confirmation'),
    });
    if (response === 'confirmed') {
      onClickDelete();
    }
  };

  return (
    <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
      <FSPrimaryButton startIcon={<EditOutlined />} onClick={onClickEdit}>
        {translate('Form.edit')}
      </FSPrimaryButton>
      <ActionsMenu
        onClickDelete={onClickDeleteConfirmBefore}
        onClickExportReport={onClickExportReport}
      />
    </Stack>
  );
}

function ActionsMenu({
  onClickDelete,
  onClickExportReport,
}: {
  onClickDelete: () => void;
  onClickExportReport: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<undefined | HTMLElement>(undefined);
  const open = Boolean(anchorEl);

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(undefined);
  };

  const onClickItem = (actionToCall: () => void) => {
    onClose();
    actionToCall();
  };

  return (
    <>
      <FSSecondaryButton startIcon={<MoreVertOutlined />} onClick={onClick}>
        {translate('Form.actions')}
      </FSSecondaryButton>
      <Menu open={open} onClose={onClose} anchorEl={anchorEl}>
        <MenuList>
          <MenuItem onClick={() => onClickItem(onClickDelete)}>
            {translate('Form.delete')}
          </MenuItem>
          <MenuItem onClick={() => onClickItem(onClickExportReport)}>
            {translate('ReportExporter.menu-item-export')}
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
}
